// extracted by mini-css-extract-plugin
export default {"weekBar":"WeekBar_weekBar__erSOW"};